export const startWithUpperCase = (str = '') => {
  const words = [];

  str.replace(/-/g, ' ').split(' ').forEach(substr => words.push(`${substr.slice(0, 1).toUpperCase()}${substr.slice(1)}`));

  return words.join(' ');
};
